import Service from "../../../Services/index";
import moment from "moment";

const invoice = {
    namespaced: true,
    state: {
        invoice_id: "",
        InvoiceList: [],
        invoiceForm: {
            id: '',
            invoice_id: null,
            customer: null,
            date: null,
            transport_type_id: null,
            invoice_status_id: 2,
            driver: null,
            details: [],
            status: null,
            order_number: "",
            order_id: "",
            shipping_fee_status: "",
            reopen_status: false,
            note: null,
            remaining_payoff: "",
            cash_back: "",
            status_have_old: false,
            status_payment: false,
            status_transport_other: false,
            status_product_return: null,
            approve_invoice_edit: 1,
            customer_other: null,
            customer_other_id: "",
            other_price: "",
            other_price_form: null,
            transport_fee: "",
            invoice_transport_details: null,
            remark: "",
            status_return: null,
            transportation: null,
            transportation_id: null,
            transport_type_name: "",
            status_before_transport: null,
            status_tax_receipt: null,
            status_receive: null,
            discount_special: "",
            other_discount: '',
            other_discount_user: '',
            status_foam_discount: false,
            status_glass_discount: false,
            status_not_pay: false,
            status_sale_receive: false,
            commission_sale: 0,
            check_if_credit: false,
            other_discount_user_model:[]
        },
        activeStatus: null,
        id_order: null,
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        transaction: {
            date: "",
            sale: "",
            customer: "",
            amount: "",
            details: [],
        },
        invoice_driver: [],
        promotion_detail: null,
        invoice_customer: [],
        on_remove_produnt: [],
    },
    mutations: {
        SET_INVOICE_LIST: (state, res) => {
            state.InvoiceList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to,
            };
        },
        SET_INVOICE_FORM: (state, res) => {
            state.invoiceForm = res;
        },
        SET_ACTIVE_STATUS: (state, status) => {
            state.activeStatus = status;
        },
        SET_ID_FROM_ORDER: (state, id) => {
            state.id_order = id;
        },
        CLEAR_FORM_DATA: (state, invoice_number) => {
            state.invoice_id = "";
            state.invoiceForm = {
                id: '',
                invoice_id: invoice_number,
                invoice_status_id: 2,
                customer: null,
                date: null,
                transport_type_id: null,
                driver: null,
                details: [],
                status: null,
                order_number: "",
                order_id: "",
                shipping_fee_status: "",
                reopen_status: false,
                note: null,
                remaining_payoff: "",
                cash_back: "",
                status_have_old: false,
                status_payment: false,
                status_transport_other: false,
                status_product_return: null,
                approve_invoice_edit: 1,
                customer_other: null,
                customer_other_id: "",
                other_price: "",
                other_price_form: null,
                transport_fee: "",
                invoice_transport_details: null,
                remark: "",
                status_return: null,
                transportation: null,
                transportation_id: null,
                transport_type_name: "",
                status_before_transport: null,
                status_tax_receipt: null,
                status_receive: null,
                status_foam_discount: false,
                status_glass_discount: false,
                discount_special: "",
                status_not_pay: false,
                status_sale_receive: false,
                commission_sale: 0,
                check_if_credit: false,
                other_discount_user_model: []
            };
            state.invoice_driver = []
        },
        CLEAR_FORM_TRANSACTION: state => {
            state.transaction = {
                date: "",
                sale: "",
                customer: "",
                amount: "",
                details: [],
            }
        },
        ADD_PRODUCT: (state, data) => {
            state.invoiceForm.details = [
                ...state.invoiceForm.details,
                {
                    ...data
                }
            ];
        },
        REMOVE_PRODUCT: (state, index) => {
            state.on_remove_produnt.push(state.invoiceForm.details[index])
            state.invoiceForm.details = state.invoiceForm.details.filter(
                (detail, itemIndex) => index !== itemIndex
            );

        },
        CLEAR_DELETE_PRODUCT: (state) => {
            state.on_remove_produnt = [];
        },
        INVOICE_DRIVER: (state, data) => {
            state.invoice_driver = data;
        },
        GET_PROMOTION: (state, res) => {
            state.promotion_detail = res;
        },
        GET_PROMOTION_DETAILS: (state, res) => {
            state.invoiceForm.details = [
                ...res
            ]
        },
        SET_INVOICE_ID: (state, res) => {
            if (res) {
                state.invoice_id = res.id;
            } else {
                state.invoice_id = "";
            }
        },
        CLEAR_DETAIL_INVOICE: (state) => {
            state.invoiceForm.details = [];
        },
    },
    actions: {
        //generate order and date now into state
        generateOrder({commit, state}) {
            let currentDate = null;
            if (moment().format("HH:mm") > "19:00")
                currentDate = moment().add(1, "days").format("YYYY-MM-DD");
            else
                currentDate = moment().format("YYYY-MM-DD");
            commit("SET_INVOICE_FORM", {
                ...state.invoiceForm,
                date: currentDate
            });
        },
        //set invoice form
        clearFormData({commit}) {
            return Service.invoice.generateTN().then(res => {
                commit("CLEAR_FORM_DATA", res);
            })
        },
        clearFormDataNew({commit}) {
            commit("CLEAR_FORM_DATA", '');
        },
        clearFormDataReOpen({commit},invoiec_number) {
            commit("CLEAR_FORM_DATA", invoiec_number);
        },
        addProduct({commit}, data) {
            commit("ADD_PRODUCT", data);
        },
        setIDFromOrder({commit}, id) {
            commit("SET_ID_FROM_ORDER", id);
        },

        removeProduct({commit}, index) {
            commit("REMOVE_PRODUCT", index);
        },

        setInvoice({commit, state}, data) {
            commit("SET_INVOICE_FORM", {
                ...state.invoiceForm,
                ...data
            });
        },
        //get invoice to table
        get({commit}, page = 1) {
            return Service.invoice.getInvoice(page).then(response => {
                commit("SET_INVOICE_LIST", response);
            });
        },

        show({commit, state}, id) {
            return Service.invoice.showInvoice(id).then(response => {
                commit("SET_INVOICE_ID", response);
                commit("SET_INVOICE_FORM", response);
            });
        },
        clearDetailInvoice({commit}) {
            commit("CLEAR_DETAIL_INVOICE");
        },
        saveInvoice({commit, state}, saveData) {
            let date = state.invoiceForm.date ? moment(state.invoiceForm.date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            const data = {
                customer_id: state.invoiceForm.customer.id,
                invoice_id: state.invoiceForm.invoice_id,
                date: date,
                driver_id: "",
                transport_type_id: state.invoiceForm.transport_type_id,
                sale_id: state.invoiceForm.customer.sale.id,
                invoice_status_id: state.invoiceForm.invoice_status_id,
                order_id: state.invoiceForm.order_id,
                shipping_fee_status: state.invoiceForm.shipping_fee_status,
                reopen_status: state.invoiceForm.reopen_status,
                remaining_payoff: state.invoiceForm.remaining_payoff,
                details: state.invoiceForm.details.map(detail => ({
                    ...detail,
                    product_id: detail.product ? detail.product.id : ''
                })),
                note: null,
                action: saveData.action,
                credit: state.invoiceForm.credit,
                check_if_credit: state.invoiceForm.check_if_credit,
                cash_back: state.invoiceForm.cash_back,
                status_have_old: state.invoiceForm.status_have_old,
                status_payment: state.invoiceForm.status_have_old,
                status_transport_other: state.invoiceForm.status_transport_other,
                status_product_return: state.invoiceForm.status_product_return,
                approve_invoice_edit: state.invoiceForm.approve_invoice_edit,
                other_price: state.invoiceForm.other_price,
                other_price_form: state.invoiceForm.other_price_form,
                customer_other_id: state.invoiceForm.customer_other_id,
                transport_fee: state.invoiceForm.transport_fee,
                invoice_transport_details: state.invoiceForm.invoice_transport_details,
                remark: state.invoiceForm.remark,
                status_return: state.invoiceForm.status_return,
                transportation_id: state.invoiceForm.transportation_id,
                status_before_transport: state.invoiceForm.status_before_transport,
                status_tax_receipt: state.invoiceForm.status_tax_receipt,
                status_receive: state.invoiceForm.status_receive,
                discount_special: state.invoiceForm.discount_special,
                other_discount: state.invoiceForm.other_discount,
                other_discount_user: state.invoiceForm.other_discount_user,
                status_foam_discount: state.invoiceForm.status_foam_discount,
                status_glass_discount: state.invoiceForm.status_glass_discount,
                status_not_pay: state.invoiceForm.status_not_pay,
                status_sale_receive: state.invoiceForm.status_sale_receive,
                commission_sale: state.invoiceForm.commission_sale,
                on_remove: state.on_remove_produnt,
            };
            if (state.invoiceForm.driver) {
                data.driver_id = state.invoiceForm.driver.id
            }
            if (!saveData.id) {
                return Service.invoice.createInvoice(data);
            } else {
                data.invoice_status_id = state.invoiceForm.invoice_status_id;
                //เพิ่มหมายเหตุสำหรับรับใบส่งของแล้ว
                if (data.invoice_status_id === 3) {
                    data.note = state.invoiceForm.note;
                }
                // //console.log(state.on_remove_produnt)
                return Service.invoice.updateInvoice(saveData.id, data).then(res => {
                    return res;
                })
            }
        },
        clear_delete_product({commit}) {
            commit("CLEAR_DELETE_PRODUCT");
        },
        delete({commit}, id) {
            return Service.invoice.deleteInvoice(id);
        },
        search({commit}, {page = 1, search}) {
            return Service.invoice
                .searchInvoice(
                    page,
                    search
                )
                .then(res => {
                    commit("SET_INVOICE_LIST", res);
                })
        },
        setInvoiceFilter({commit}, {page = "", status = 1}) {
            commit("SET_ACTIVE_STATUS", status);
            return Service.invoice.filterInvoice(page, status).then(res => {
                commit("SET_INVOICE_LIST", res);
            });
        },
        approveInvoiceEdit({commit}, id) {
            return Service.invoice.approveInvoiceEdit(id);
        },
        checkInvoiceFromDriver({commit}, driver_id) {
            return Service.invoice.checkInvoiceFromDriver(driver_id).then(data => {
                commit("INVOICE_DRIVER", data);
            })
        },
        promotionInvoice({commit}, data) {
            return Service.invoice.PromotionInvoice(data).then(res => {
                commit("GET_PROMOTION", res);
            })
        },
        promotionInvoiceMultiple({commit}, data) {
            return Service.invoice.PromotionInvoiceMultiple(data).then(res => {
                commit("GET_PROMOTION_DETAILS", res);
            })
        },
        selectInvoiceAll({commit}, data) {
            return Service.invoice.selectInvoiceAll(data);
        },
        getInvoiceAll({commit}) {
            return Service.invoice.getInvoiceAll();
        },
        getInvoiceTransportPrice({commit}, form) {
            return Service.invoice.getInvoiceTransportPrice(form);
        },
        printPromotionReport({commit}, data) {
            return Service.invoice.printPromotionInvoiceReport(data);
        },

        //save&print invoice PDF
        saveInvoicePDF({commit, state}, id) {
            const data = {
                customer_id: state.invoiceForm.customer.id,
                invoice_id: state.invoiceForm.invoice_id,
                date: moment(state.invoiceForm.date).format("YYYY-MM-DD"),
                driver_id: "",
                transport_type_id: state.invoiceForm.transport_type_id,
                sale_id: state.invoiceForm.customer.sale_id,
                invoice_status_id: 2,
                order_id: state.invoiceForm.order_id,
                shipping_fee_status: state.invoiceForm.shipping_fee_status,
                reopen_status: state.invoiceForm.reopen_status,
                remaining_payoff: state.invoiceForm.remaining_payoff,
                details: state.invoiceForm.details.map(detail => ({
                    ...detail,
                    product_id: detail.product.id
                })),
                note: null,
                credit: state.invoiceForm.credit,
                check_if_credit: state.invoiceForm.check_if_credit,
                cash_back: state.invoiceForm.cash_back,
                status_have_old: state.invoiceForm.status_have_old,
                status_payment: state.invoiceForm.status_have_old,
                status_transport_other: state.invoiceForm.status_transport_other,
                status_product_return: state.invoiceForm.status_product_return,
                approve_invoice_edit: state.invoiceForm.approve_invoice_edit,
                other_price: state.invoiceForm.other_price,
                other_price_form: state.invoiceForm.other_price_form,
                customer_other_id: state.invoiceForm.customer_other_id,
                transport_fee: state.invoiceForm.transport_fee,
                invoice_transport_details: state.invoiceForm.invoice_transport_details,
                remark: state.invoiceForm.remark,
                status_return: state.invoiceForm.status_return,
                transportation_id: state.invoiceForm.transportation_id,
                status_foam_discount: state.invoiceForm.status_foam_discount,
                status_glass_discount: state.invoiceForm.status_glass_discount,

            };
            if (state.invoiceForm.driver) {
                data.driver_id = state.invoiceForm.driver.id
            }
            if (!id) { //create & print
                return Service.invoice.createInvoicePDF(data);
            } else { //update & print
                return Service.invoice.updateInvoicePDF(id, data);
            }
        },

        changeInvoiceStatus({commit}, data) {
            return Service.invoice.changeInvoiceStatus(data);
        },
        reportInvoice({commit}, data) {
            return Service.invoice.reportInvoice(data);
        },
        getInvoiceByCustomerId({commit}, data) {
            return Service.invoice.getInvoiceByCustomerId(data);
        },
        updateDriverInvoice({commit}, data) {
            return Service.invoice.updateInvoiceDriver(data);
        },
        printMultiInvoicePDF({commit}, id) {
            return Service.invoice.printMultiInvoice(id);
        }
    }
};

export default invoice;
